export default "assets/images/chateaux-logos/belgrave-4cba56e3.png";